export const TOGGLE_PHONE_CONNECTION = 'TOGGLE_PHONE_CONNECTION';
export const TOGGLE_PHONE_REGISTRATION = 'TOGGLE_PHONE_REGISTRATION';
export const SET_CALL_REMOTE = 'SET_CALL_REMOTE';
export const SET_CALL_STATUS = 'SET_CALL_STATUS';
export const SET_DIAL_PAD_ACTIVE = 'SET_DIAL_PAD_ACTIVE';
export const SET_CALL_LOGS = 'SET_CALL_LOGS';
export const ADD_CALL = 'ADD_CALL';
export const REMOVE_CALL = 'REMOVE_CALL';
export const UPDATE_CALL_ID = 'UPDATE_CALL_ID';
export const SET_NOTIFYING_CALL_LOG = 'SET_NOTIFYING_CALL_LOG';
export const SET_REF = 'SET_REF';
export const CLEAR_REF = 'CLEAR_REF';
